import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useCustomerAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.get("/customer/auth/session", {
          headers: { "X-Session-Id": sessionId },
          withCredentials: true,
        });
        // Clear the hash so we don't re-process
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        const back = window.location.pathname;
        const communityReturn = ["/experience", "/events", "/bulletin", "/become-a-jenova-girl", "/prive", "/community-wall", "/my-jenova"].some((p) => back.startsWith(p));
        navigate(communityReturn ? back : "/account", { replace: true, state: { user: data.user } });
      } catch (err) {
        console.error("Auth callback failed:", err);
        navigate("/?auth_error=1", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F6]">
      <div className="text-center">
        <Loader2 strokeWidth={1.5} className="w-10 h-10 mx-auto animate-spin text-stone-500" />
        <p className="mt-6 font-serif italic text-2xl text-stone-600">Welcoming you in…</p>
      </div>
    </div>
  );
}
